import axios from 'axios'

class VersionCheckService {
	constructor(interval = 60000) {
		this.currentVersion = null
		this.currentSwFilename = null
		this.interval = interval
		this.timer = null
		this.onUpdate = null
	}

	setOnUpdate(callback) {
		this.onUpdate = callback
	}

	static async fetchVersion() {
		try {
			const response = await axios.get(`/version.json?t=${Date.now()}`, {
				headers: { 'Cache-Control': 'no-cache' }
			})
			return {
				version: response.data.version,
				sw: response.data.sw
			}
		} catch (error) {
			console.error('Error fetching version:', error)
			return null
		}
	}

	async checkVersion() {
		const { version, sw } = await VersionCheckService.fetchVersion()
		if (!version || !sw) return
		if (!this.currentVersion) {
			this.currentVersion = version
			this.currentSwFilename = sw

			if ('serviceWorker' in navigator && sw) {
				const registrations = await navigator.serviceWorker.getRegistrations()

				await Promise.all(registrations.map((reg) => reg.unregister()))
				console.log('[SW] Unregistered all existing service workers')

				try {
					await navigator.serviceWorker.register(`/${sw}`)
					console.log(`[SW] Registered service worker: ${sw}`)
				} catch (e) {
					console.error(`[SW] Failed to register ${sw}:`, e)
				}
			}

			return
		}

		let shouldTriggerUpdate = false

		if (version && version !== this.currentVersion) {
			this.currentVersion = version
			shouldTriggerUpdate = true
		}

		if (sw && sw !== this.currentSwFilename) {
			this.currentSwFilename = sw
			try {
				await axios.get(`/${sw}`, {
					headers: { 'Cache-Control': 'no-cache' }
				})
				const registration = await navigator.serviceWorker.register(`/${sw}`)
				if (registration.installing) {
					registration.installing.addEventListener('statechange', (e) => {
						if (
							e.target.state === 'installed' &&
							navigator.serviceWorker.controller
						) {
							if (this.onUpdate) this.onUpdate(this.currentVersion)
						}
					})
				} else {
					this.onUpdate(this.currentVersion)
				}
			} catch (err) {
				console.error('[SW] Failed to update:', err)
				this.onUpdate(this.currentVersion)
			}
		} else if (shouldTriggerUpdate) {
			this.onUpdate(this.currentVersion)
		}
	}

	async start() {
		await this.checkVersion()

		this.timer = setInterval(() => {
			this.checkVersion()
		}, this.interval)
	}

	stop() {
		if (this.timer) {
			clearInterval(this.timer)
			this.timer = null
		}
	}
}

export default VersionCheckService
